"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixDashes = void 0;
function fixDashes(text) {
    return (text
        // replaces triple dash to mdash
        .replace(/-{3}/g, "—")
        // replaces double dash to ndash
        .replace(/-{2}/g, "–"));
}
exports.fixDashes = fixDashes;
